import { CSSObject, DefaultTheme } from "styled-components";
import { useTheme } from "../Theme/ThemeProvider";
import { vfxTheme } from "../Theme/theme";

interface SnackBarStyles {
  container: CSSObject;
  closeButton: CSSObject;
  alert: CSSObject;
}

const useSnackBarStyles = (): SnackBarStyles => {
  
  return {
    container: {
      position: "fixed",
      right: `${vfxTheme.spaceUnits.sp01 * 4}px`,
      bottom: `${vfxTheme.spaceUnits.sp01 * 4}px`,
      width: "27%",
    },
    alert: {
      color: vfxTheme.palette.white,
    },
    closeButton: {
      position: "fixed",
      right: `${vfxTheme.spaceUnits.sp01 * 7}px`,
    },
  };
};

export default useSnackBarStyles;
